// Local emergency resources
const emergencyResources = [
    {
      id: 'crisis',
      title: 'Crisis Text Line',
      description: 'Text HOME to 741741 for free 24/7 crisis counseling.',
      phone: '741741',
      website: 'https://www.crisistextline.org/'
    },
    {
      id: 'suicide',
      title: 'National Suicide Prevention Lifeline',
      description: '24/7, free and confidential support for people in distress.',
      phone: '988',
      website: 'https://988lifeline.org/'
    },
    {
      id: 'domestic',
      title: 'National Domestic Violence Hotline',
      description: 'Talk with someone who is trained to help.',
      phone: '1-800-799-7233',
      website: 'https://www.thehotline.org/'
    },
    {
      id: 'samhsa',
      title: 'SAMHSA National Helpline',
      description: 'Treatment referral and information service for individuals facing mental health or substance use disorders.',
      phone: '1-800-662-4357',
      website: 'https://www.samhsa.gov/find-help/national-helpline'
    },
    {
      id: 'veterans',
      title: 'Veterans Crisis Line',
      description: 'Connect with caring, qualified responders with the Department of Veterans Affairs.',
      phone: '988 (press 1)',
      website: 'https://www.veteranscrisisline.net/'
    },
    {
      id: 'trevor',
      title: 'The Trevor Project',
      description: 'Crisis intervention and suicide prevention services for LGBTQ young people.',
      phone: '1-866-488-7386',
      website: 'https://www.thetrevorproject.org/'
    }
  ];
  
  export default emergencyResources;